import { Center, Spinner } from '@chakra-ui/react'
import React, { lazy, Suspense } from 'react'
import { Helmet } from 'react-helmet-async'
import type { FileDetailsResponse } from '../../interfaces/FileDetailsResponse'

const FileDetailLayout = lazy(
  () => import('../../layouts/MediaLibrary/FileDetailLayout'),
)

const FallbackSpinner = (): React.ReactElement => (
  <Center height="100%">
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="appPaleGrey"
      color="appBlue"
      size="xl"
    />
  </Center>
)

const FileDetailPage = ({
  fileDetails,
  loading,
  setFileDetails,
}: {
  fileDetails: FileDetailsResponse | undefined
  loading: boolean
  setFileDetails?: React.Dispatch<
    React.SetStateAction<FileDetailsResponse | undefined>
  >
}): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>{fileDetails?.name ?? 'File Detail'}</title>
      <meta name="description" content="File Detail page" />
    </Helmet>
    {fileDetails ? (
      <Suspense fallback={<FallbackSpinner />}>
        <FileDetailLayout
          fileDetails={fileDetails}
          setFileDetails={setFileDetails}
          loading={loading}
        />
      </Suspense>
    ) : (
      <FallbackSpinner />
    )}
  </React.Fragment>
)

export default FileDetailPage
